import { isInteractiveSession } from '@cli-utils/terminal.js'
import { listSchemaNames } from '@core-engine/schema/schema-reader/list-schema-names.js'
import { fail } from '../schema-prompts/fail.js'
import { promptSelectValue } from './prompt-select-value.js'

export async function resolveSchemaNameInteractively(
  schemasDir: string,
  schemaName: string | undefined
): Promise<string> {
  if (schemaName) {
    return schemaName
  }

  if (!isInteractiveSession()) {
    fail('Schema name is required in non-interactive sessions.')
  }

  const schemaNames = listSchemaNames(schemasDir)
  if (schemaNames.length === 0) {
    fail(`No schemas found in ${schemasDir}.`)
  }

  return promptSelectValue(
    'Generated schema',
    schemaNames.map((name) => ({ value: name, label: name }))
  )
}
